"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
const google_1 = require("@react-oauth/google");
const react_2 = require("react");
const react_cookie_1 = require("react-cookie");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const Alphaeon_Credit_Logo_BW_png_1 = __importDefault(require("images/Alphaeon_Credit_Logo_BW.png"));
const utils_1 = require("utils");
const Toast_1 = __importDefault(require("../components/Toast"));
function Login({}) {
    const [, setCookie] = (0, react_cookie_1.useCookies)(['portalUser']);
    const history = (0, react_router_dom_1.useHistory)();
    const { state } = (0, react_router_dom_1.useLocation)();
    const [toastVisible, setToastVisible] = (0, react_2.useState)(false);
    (0, google_1.useGoogleOneTapLogin)({
        auto_select: true,
        cancel_on_tap_outside: false,
        onSuccess: (codeResponse) => {
            if (!(0, utils_1.getCookie)('portalUser')) {
                setCookie('portalUser', { ...codeResponse, expiration: Date.now() + 3.54e6 }, {
                    expires: new Date(Date.now() + 3.54e6), //expires in 59 minutes
                });
            }
            history.push(state?.from || `${config_1.PATH.INTERNAL_PORTAL}/home`);
        },
        onError: () => setToastVisible(true),
    });
    return ((0, jsx_runtime_1.jsx)("div", { className: "login-container", children: (0, jsx_runtime_1.jsxs)(react_1.CCard, { className: "login-card", children: [(0, jsx_runtime_1.jsx)(react_1.CCardImage, { src: Alphaeon_Credit_Logo_BW_png_1.default, className: "alphaeon-logo", alt: "Alphaeon Credit" }), (0, jsx_runtime_1.jsx)(react_1.CCardTitle, { as: "h2", children: "Internal Portal" }), (0, jsx_runtime_1.jsx)(react_1.CCardTitle, { as: "h5", children: "Welcome Back" }), (0, jsx_runtime_1.jsx)(google_1.GoogleLogin, { onSuccess: (codeResponse) => {
                        setCookie('portalUser', { ...codeResponse, expiration: Date.now() + 3.54e6 }, {
                            expires: new Date(Date.now() + 3.54e6), //expires in 59 minutes
                        });
                        history.push(state?.from || `${config_1.PATH.INTERNAL_PORTAL}/home`);
                    }, onError: () => setToastVisible(true) }), (0, jsx_runtime_1.jsx)(Toast_1.default, { visible: toastVisible, setVisible: setToastVisible, bodyText: "Error Logging In" })] }) }));
}
exports.default = Login;
